const LOWER_CASE_RGX = /(?=.*?[a-z])/g;
const UPPER_CASE_RGX = /(?=.*?[A-Z])/g;
const DIGIT_RGX = /(?=.*?[0-9])/g;
const SPECIAL_CHAR_RGX = /(?=.*?[#?!@$%^&*-,._])/g;
export const WEAK_LENGTH = 6;
const STRONG_LENGTH = 16;

export enum PASSWORD_STRENGTH {
  EMPTY = 0,
  WEAK = 1,
  MEDIUM = 3,
  STRONG = 5,
}

export function getPasswordStrength(password: string | undefined): number {
  if (!password) {
    return PASSWORD_STRENGTH.EMPTY;
  }

  let passwordStrength = PASSWORD_STRENGTH.EMPTY;

  if (LOWER_CASE_RGX.test(password)) {
    passwordStrength += 1;
  }

  if (UPPER_CASE_RGX.test(password)) {
    passwordStrength += 1;
  }

  if (DIGIT_RGX.test(password)) {
    passwordStrength += 1;
  }

  if (SPECIAL_CHAR_RGX.test(password)) {
    passwordStrength += 1;
  }

  if (password.length >= WEAK_LENGTH && password.length < STRONG_LENGTH) {
    passwordStrength += 1;
  }

  if (password.length >= STRONG_LENGTH) {
    passwordStrength += 2;
  }

  return passwordStrength;
}
